import {Tabs, withStyles} from '@material-ui/core';
import {APP} from '../../../style/variable';
const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: APP.COLOR.TABS.INDICATOR,
    height: '0.3rem',
    borderTopLeftRadius: '3pt',
    borderTopRightRadius: '3pt',
    bottom: '3.3px',
    '& >span': {
      maxWidth: 40,
      width: '100%'
    }
  },
  scroller: {
    display: 'flex'
  }
})(Tabs);

export default StyledTabs;
